<template>
	<div class="createStudyPage">

		<h1 class="d-sr-only">Researcher Site Create Study Page</h1>

		<v-stepper v-model="e1" >
			<v-stepper-header class="createStudyHeader">
				<foe-stepper-step
					:complete="e1 > 1"
					step="1"
					complete-icon="check"
					@click="goTo1"
					color="#B85623"
					class="createStudyHeaderStepper"
					tabIndex="0"
					v-on:stepper-enter="goTo1"
					role="button"
				>
					<span v-if="e1===1" style="text-decoration: underline;">Create a New Study</span>
					<span v-else>Create a New Study</span>
				</foe-stepper-step>
				<v-divider></v-divider>
				<foe-stepper-step
					:complete="e1 > 2"
					step="2"
					complete-icon="check"
					@click="goTo2"
					color="#B85623"
					class="createStudyHeaderStepper"
					tabIndex="0"
					v-on:stepper-enter="goTo2"
					role="button"
				>
					<span v-if="e1===2" style="text-decoration: underline;">Specify Study Details</span>
					<span v-else>Specify Study Details</span>
				</foe-stepper-step>
				<v-divider></v-divider>
				<foe-stepper-step
					:complete="e1 > 3"
					step="3"
					complete-icon="check"
					@click="goTo3"
					color="#B85623"
					class="createStudyHeaderStepper"
					tabIndex="0"
					v-on:stepper-enter="goTo3"
					role="button"
				>
					<span v-if="e1===3" style="text-decoration: underline;">Select Optional Study Modules</span>
					<span v-else>Select Optional Study Modules</span>
				</foe-stepper-step>
				<v-divider></v-divider>
				<foe-stepper-step
					step="4"
					@click="goTo4"
					color="#B85623"
					class="createStudyHeaderStepper"
					tabIndex="0"
					v-on:stepper-enter="goTo4"
					role="button"
				>
					<span v-if="e1===4" style="text-decoration: underline;">Summary of New Study</span>
					<span v-else>Summary of New Study</span>
				</foe-stepper-step>
			</v-stepper-header>
<!-- second header for lower viewport (zoomed in) -->
			<v-stepper-header class="createStudyHeader2">
				<foe-stepper-step
					:complete="e1 > 1"
					step="1"
					complete-icon="check"
					@click="goTo1"
					color="#B85623"
					class="createStudyHeaderStepper"
					tabIndex="0"
					v-on:stepper-enter="goTo1"
					role="button"
				>
					<span v-if="e1===1" style="text-decoration: underline;">Create</span>
					<span v-else>Create </span>
				</foe-stepper-step>
				<v-divider></v-divider>
				<foe-stepper-step
					:complete="e1 > 2"
					step="2"
					complete-icon="check"
					@click="goTo2"
					color="#B85623"
					class="createStudyHeaderStepper"
					tabIndex="0"
					v-on:stepper-enter="goTo2"
					role="button"
				>
					<span v-if="e1===2" style="text-decoration: underline;"> Details</span>
					<span v-else>Details</span>
				</foe-stepper-step>
				<v-divider></v-divider>
				<foe-stepper-step
					:complete="e1 > 3"
					step="3"
					complete-icon="check"
					@click="goTo3"
					color="#B85623"
					class="createStudyHeaderStepper"
					tabIndex="0"
					v-on:stepper-enter="goTo3"
					role="button"
				>
					<span v-if="e1===3" style="text-decoration: underline;"> Modules</span>
					<span v-else> Modules</span>
				</foe-stepper-step>
				<v-divider></v-divider>
				<foe-stepper-step
					step="4"
					@click="goTo4"
					color="#B85623"
					class="createStudyHeaderStepper"
					tabIndex="0"
					v-on:stepper-enter="goTo4"
					role="button"
				>
					<span v-if="e1===4" style="text-decoration: underline;">Summary </span>
					<span v-else>Summary </span>
				</foe-stepper-step>
			</v-stepper-header>
			<!-- Stepper contents -->
			<v-stepper-items class="create-study-stepper-content">
				<!-- Step 1 -->
				<v-stepper-content step="1">

					<h2 class="d-sr-only">Create a New Study</h2>

					<v-card class="card-create-step" outlined @keydown.enter.prevent>
						<div class="d-sr-only-focusable float-right text-decoration-underline" tabindex="0" @keyup.enter="focusToTop" @click="focusToTop" ref="firstFocus" role="link">Go to top of page</div>
						<p>All sections on this page are required</p>
						<v-form
							ref="form1"
							v-model="valid1"
							lazy-validation
						>
							<v-row>
								<v-col md="2">
									<h3 class="left-align"><label for="form-study-name">Study name:</label></h3>
								</v-col>
								<v-col md="4">
									<v-text-field
										v-model="studyName"
										hide-details="auto"
										outlined
										counter="40"
										maxlength="40"
										:rules="studyNameRules"
										id="form-study-name"
										name="form-study-name"
										aria-describedby="form-study-name-explanation-box"
										:aria-label="'Study name: ' + studyName + ' ' + studyName.length + ' characters used. Max character limit is 40. Possible ' + (40 - studyName.length) + ' characters remaining.'"
									></v-text-field>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-study-name-explanation-box"
										:color="'green'"
										:displayText="'Provide a short study name to distinguish it from other studies that you’ve created. This is not seen by respondents.'">
									</explanation-box>
								</v-col>
							</v-row>
							<v-divider inset></v-divider>
							<v-row>
								<v-col md="2">
									<h3 class="left-align"><label for="form-study-description">Study description:</label></h3>
								</v-col>
								<v-col md="4">
									<v-textarea
										v-model="studyDescription"
										hide-details="auto"
										outlined
										counter="400"
										maxlength="400"
										:rules="studyDescriptionRules"
										id="form-study-description"
										name="form-study-description"
										aria-describedby="form-study-description-explanation-box"
										:aria-label="'Study description: ' + studyDescription + ' ' + studyDescription.length + ' characters used. Max character limit is 400. Possible ' + (400 - studyDescription.length) + ' characters remaining.'"
									></v-textarea>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-study-description-explanation-box"
										:fullBox=true
										:color="'green'"
										:displayText="'Briefly describe the study. This will be used internally to monitor use of the ASA24 system; data will only be reported at the aggregate level and never used to identify individual studies. This is not seen by respondents.<br><br>' +
											'These details may include general information about your study population or a novel administration of ASA24, for example. You can use this space to clarify any responses to “Study Characteristics” below that you feel are not adequately captured.'"
									></explanation-box>
								</v-col>
							</v-row>
							<v-divider inset></v-divider>
							<v-row>
								<v-col md="2">
									<h3 class="left-align">Study Characteristics (Check all that apply):</h3>
								</v-col>
								<v-col md="4">
									<p class="left-align p2">Study population:</p>

									<fieldset class="border-0">
										<legend class="d-sr-only">
											Study characteristics (Check all that apply). Study population:
										</legend>

										<v-checkbox
											v-model="studyCharacteristics"
											v-for="(characteristic, i) in studyCharacteristicsCheckboxes"
											:key="characteristic.key + i"
											:label="characteristic.value"
											:value="characteristic.key"
											:hide-details="i !== studyCharacteristicsCheckboxes.length - 1"
											:rules="checkboxRules"
											:id="'form-study-characteristics-' + i"
											aria-describedby="form-study-characteristics-explanation-box"
										></v-checkbox>
									</fieldset>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-study-characteristics-explanation-box"
										:fullBox=true
										:color="'green'"
										:displayText="'Please note, the information you provide about your study population’s characteristics will only be used internally to monitor use of the ASA24 system, such as specific age groups, vulnerable populations, and for awareness of studies that may be using ASA24 in ways that NCI receives questions about, e.g. in low literacy populations or using interview-administration rather than self-administration. Data will only be reported at the aggregate level and never used to identify individual studies.'"
									></explanation-box>
								</v-col>
							</v-row>
							<v-divider inset></v-divider>
							<v-row>
								<v-col md="6" cols="12">
									<v-row>
										<v-col md="4">
											<h3 class="left-align"><label for="form-study-abbreviation">Study abbreviation:</label></h3>
										</v-col>
										<v-col cols="8">
											<v-form
												ref="formAbbreviation"
												v-model="validAbbreviation"
												lazy-validation
											>
												<v-text-field
													v-model="studyAbbreviation"
													hide-details="auto"
													outlined
													counter="8"
													maxlength="8"
													:rules="studyAbbreviationRules"
													v-on:keypress="isLetter($event)"
													id="form-study-abbreviation"
													name="form-study-abbreviation"
													aria-describedby="form-suggested-abbreviation-explanation-box"
													:aria-label="'Study abbreviation: ' + studyAbbreviation + ' ' + studyAbbreviation.length + ' characters used. Max character limit is 8. Possible ' + (8 - studyAbbreviation.length) + ' characters remaining.'"
												></v-text-field>
											</v-form>
										</v-col>
									</v-row>
									<v-row v-show="abbrevitionSuggestions.length !== 0">
										<v-col md="4">
											<h3 class="left-align"><label for="form-suggested-abbreviation">Suggested abbreviations:</label></h3>
										</v-col>
										<v-col cols="8">
											<fieldset class="border-0">
												<legend class="d-sr-only">
													Suggested abbreviations:
											</legend>
											<v-radio-group
												v-model="selectedSuggestion"
												id="form-suggested-abbreviation"
											>
												<v-radio
													v-for="(suggestion, i) in abbrevitionSuggestions"
													:key="suggestion + i"
													:label="suggestion"
													:value="suggestion"
													aria-describedby="form-suggested-abbreviation-explanation-box"
												></v-radio>
											</v-radio-group>
										</fieldset>
										</v-col>
									</v-row>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-suggested-abbreviation-explanation-box"
										:color="'red'"
										:fullBox=true
										:displayText="'Specify a study abbreviation to uniquely identify your study in the ASA24 system. The study abbreviation is a combination of three to eight letters and cannot contain numbers or special characters. <br><br>It is used as a prefix for your respondent usernames. For this reason, it is a good idea to use an abbreviation that will be meaningful to your respondents. For example, if a study abbreviation is FRUIT, sample usernames include FRUIT101 or FRUIT1001.'"
									></explanation-box>
								</v-col>
							</v-row>
							<v-divider inset></v-divider>
							<v-row>
								<v-col md="2">
									<h3 class="left-align">Purpose of study:</h3>
								</v-col>
								<v-col md="4">
									<fieldset class="border-0">
										<legend class="d-sr-only">
											Purpose of study:
										</legend>
										<v-radio-group
											v-model="studyPurpose"
											:rules="radioRules"
											id="form-study-purpose"
										>
											<v-radio
												v-for="(purpose, i) in this.$createStudyLists.studyPurposes"
												:key="purpose + i"
												:label="purpose"
												:value="purpose"
												aria-describedby="form-study-purpose-explanation-box"
											></v-radio>
										</v-radio-group>
										<div v-if="studyPurpose && studyPurpose == this.$createStudyLists.studyPurposes[4]">
											<v-text-field
												v-model="studyPurposeOther"
												label="Other (specify)"
												hide-details="auto"
												outlined
												aria-describedby="form-study-purpose-explanation-box"
												:aria-label="'Other (specify): ' + studyPurposeOther"
											></v-text-field>
										</div>
									</fieldset>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-study-purpose-explanation-box"
										:color="'green'"
										:displayText="'Select the primary reason for creating this study.<br><br>This information is collected for internal tracking purposes only and does not affect study administration.'"
									></explanation-box>
								</v-col>
							</v-row>
							<v-divider inset></v-divider>
							<!-- Values to check for are based on list position in /assets/global_text/createStudyLists -->
							<div v-if="studyPurpose && studyPurpose == this.$createStudyLists.studyPurposes[0]">
								<v-row>
									<v-col md="2">
										<h3 class="left-align"><label for="form-research-type">Type of research? (Check all that apply)</label></h3>
									</v-col>
									<v-col md="4">
										<fieldset class="border-0">
											<legend class="d-sr-only">
												Type of research? (Check all that apply)
											</legend>

											<v-checkbox v-model="researchType"
																	v-for="(type, i) in researchTypeCheckboxes"
																	:key="type + i"
																	:label="type"
																	:value="type"
																	:rules="checkboxRules"
																	:hide-details="i !== researchTypeCheckboxes.length - 1"
																	:id="'form-research-type-' + i"
																	aria-describedby="form-research-type-explanation-box"></v-checkbox>
											<div v-if="researchType.includes(this.$createStudyLists.researchTypes[5])">
												<v-text-field v-model="researchTypeOther"
																			label="Other (specify)"
																			hide-details="auto"
																			outlined
																			aria-describedby="form-research-type-explanation-box"
																			:aria-label="'Other (specify): ' + researchTypeOther">
													</v-text-field>
											</div>

										</fieldset>

									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-research-type-explanation-box"
											:color="'green'"
											:displayText="'Select the type of research method for this study.<br><br>The purpose of the study is collected for internal tracking purposes only and does not affect study administration.'"
										></explanation-box>
									</v-col>
								</v-row>
								<v-divider inset></v-divider>
								<v-row>
									<v-col md="2">
										<h3 class="left-align"><label for="form-funds-received">Have funds been received for this study?</label></h3>
									</v-col>
									<v-col md="4">
										<fieldset class="border-0">
											<legend class="d-sr-only">
												Have funds been received for this study?
											</legend>
											<v-radio-group
												v-model="fundsReceived"
												:rules="radioRules"
												id="form-funds-received"
											><v-radio v-for="(fundOption, i) in this.$createStudyLists.fundsReceivedOptions"
													:key="fundOption.key + i"
													:label="fundOption.value"
													:value="fundOption.key"
													aria-describedby="form-funds-received-explanation-box"
												></v-radio>
												<div v-if="fundsReceived.includes(this.$createStudyLists.FUNDS_OTHER.key)">
													<v-text-field v-model="fundsReceivedOther"
																				label="Other (specify)"
																				hide-details="auto"
																				outlined
																				aria-describedby="form-funds-received-explanation-box"
																				:aria-label="'Other (specify): ' + fundsReceivedOther"></v-text-field>
												</div>
											</v-radio-group>
										</fieldset>
									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-funds-received-explanation-box"
											:color="'green'"
											:displayText="'Specify whether funding was received for this study.<br><br>This information is collected for internal tracking purposes only and does not affect study administration.'"
										></explanation-box>
									</v-col>
								</v-row>
							</div>
							<div v-if="fundsReceived && fundsReceived == this.$createStudyLists.FUNDS_YES.key">
								<v-divider inset></v-divider>
								<v-row>
									<v-col md="2">
										<h3 class="left-align"><label for="form-funds-received">Funding source? (Check all that apply)</label></h3>
									</v-col>
									<v-col md="4">

										<fieldset class="border-0">
											<legend class="d-sr-only">
												Funding source? (Check all that apply)
											</legend>

											<v-checkbox v-model="openSubFunds"
																	:label="fundingSourcesCheckboxes[0].name"
																	hide-details
																	aria-describedby="form-study-characteristics-funds-received"></v-checkbox>
											<div class="sub-funds" v-if="openSubFunds && openSubFunds == true">
												<v-checkbox v-model="fundingSource"
																		v-for="(subFund, i) in fundingSourcesCheckboxes[0].subCategories"
																		:key="subFund.name + i"
																		:label="subFund.name"
																		:value="subFund.alias"
																		:rules="checkboxRules"
																		hide-details></v-checkbox>
												<div v-if="fundingSource.includes(this.$createStudyLists.fundingSources[0].subCategories[5].alias)">
													<v-text-field v-model="fundingSourceNIHOther"
																				label="Other (specify)"
																				hide-details="auto"
																				outlined
																				:aria-label="'Other (specify): ' + fundingSourceNIHOther"></v-text-field>
												</div>
											</div>
											<v-checkbox v-model="openAgencies"
																	:label="fundingSourcesCheckboxes[1].name"
																	hide-details
																	aria-describedby="form-study-characteristics-funds-received"></v-checkbox>
											<div class="sub-funds" v-if="openAgencies && openAgencies == true">
												<v-checkbox v-model="fundingSource"
																		v-for="(subFund, i) in fundingSourcesCheckboxes[1].subCategories"
																		:key="subFund.name + i"
																		:label="subFund.name"
																		:value="subFund.alias"
																		:rules="checkboxRules"
																		hide-details></v-checkbox>
												<div v-if="fundingSource.includes(this.$createStudyLists.fundingSources[1].subCategories[4].alias)">
													<v-text-field v-model="fundingSourceAgencyOther"
																				label="Other (specify)"
																				hide-details="auto"
																				outlined
																				:aria-label="'Other (specify): ' + fundingSourceAgencyOther"></v-text-field>
												</div>
											</div>
											<v-checkbox v-model="fundingSource"
																	:label="fundingSourcesCheckboxes[2].name"
																	:value="fundingSourcesCheckboxes[2].name"
																	:rules="checkboxRules"
																	id="form-funding-source"
																	aria-describedby="form-study-characteristics-funds-received"></v-checkbox>
											<div v-if="fundingSource.includes(this.$createStudyLists.fundingSources[2].name)">
												<v-text-field v-model="fundingSourceOther"
																			label="Other (specify)"
																			hide-details="auto"
																			outlined
																			:aria-label="'Other (specify): ' + fundingSourceOther"></v-text-field>
											</div>

										</fieldset>

									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-study-characteristics-funds-received"
											:color="'green'"
											:displayText="'Specify the funding source and if it was funded by NIH, specify the institution and the grant or contract number.<br><br>This information is collected for internal tracking purposes only and does not affect study administration.'"
										></explanation-box>
									</v-col>
								</v-row>
							</div>
							<div v-if="openSubFunds && openSubFunds == true">
								<v-divider inset></v-divider>
								<v-row>
									<v-col md="2">
										<h3 class="left-align">Grant or contract number:</h3>
									</v-col>
									<v-col md="4">
										<v-text-field
											v-model="contractNum"
											label="Grant or Contract Number"
											hide-details="auto"
											outlined
											:rules="requiredFieldRule"
											id="form-contract-num"
											name="form-contract-num"
											:aria-label="'Grant or contract number: ' + contractNum"
										></v-text-field>
									</v-col>
									<v-col md="6" cols="12">
									</v-col>
								</v-row>
							</div>
							<v-divider inset></v-divider>
							<v-row>
								<v-col md="2">
									<h3 class="left-align">Researcher affiliation of main researcher/PI (Check all that apply):</h3>
								</v-col>
								<v-col md="4">
									<fieldset class="border-0">
										<legend class="d-sr-only">
											Researcher affiliation of main researcher/PI (Check all that apply):
										</legend>
										<v-checkbox
											v-model="researcherAffiliation"
											:label="researcherAffiliationsCheckboxes[0]"
											:value="researcherAffiliationsCheckboxes[0]"
											:hide-details="true"
											:rules="checkboxRules"
											:id="'form-researcher-affiliation-' + '0'"
											aria-describedby="form-researcher-affiliation-explanation-box"
										></v-checkbox>
										<v-checkbox
											v-model="researcherAffiliation"
											:label="researcherAffiliationsCheckboxes[1]"
											:value="researcherAffiliationsCheckboxes[1]"
											:hide-details="true"
											:rules="checkboxRules"
											:id="'form-researcher-affiliation-' + '1'"
											aria-describedby="form-researcher-affiliation-explanation-box"
										></v-checkbox>
										<!-- Input box if above checkbox is selected -->
										<div v-if="researcherAffiliation.includes(this.$createStudyLists.researcherAffiliations[1])">
											<br>
											<v-text-field
												v-model="researcherAffiliationAgency"
												label="Specify Agency Name"
												hide-details="auto"
												outlined
											></v-text-field>
										</div>
										<v-checkbox
											v-model="researcherAffiliation"
											:label="researcherAffiliationsCheckboxes[2]"
											:value="researcherAffiliationsCheckboxes[2]"
											:hide-details="true"
											:rules="checkboxRules"
											:id="'form-researcher-affiliation-' + '2'"
										></v-checkbox>
										<v-checkbox
											v-model="researcherAffiliation"
											:label="researcherAffiliationsCheckboxes[3]"
											:value="researcherAffiliationsCheckboxes[3]"
											:hide-details="true"
											:rules="checkboxRules"
											:id="'form-researcher-affiliation-' + '3'"
										></v-checkbox>
										<v-checkbox
											v-model="researcherAffiliation"
											:label="researcherAffiliationsCheckboxes[4]"
											:value="researcherAffiliationsCheckboxes[4]"
											:hide-details="true"
											:rules="checkboxRules"
											:id="'form-researcher-affiliation-' + '4'"
										></v-checkbox>
										<!-- Input box if above checkbox is selected -->
										<div v-if="researcherAffiliation.includes(this.$createStudyLists.researcherAffiliations[4])">
											<br>
											<v-text-field
												v-model="researcherAffiliationOrganization"
												label="Specify Organization Name"
												hide-details="auto"
												outlined
												aria-describedby="form-researcher-affiliation-explanation-box"
											></v-text-field>
										</div>
										<v-checkbox
											v-model="researcherAffiliation"
											:label="researcherAffiliationsCheckboxes[5]"
											:value="researcherAffiliationsCheckboxes[5]"
											:hide-details="true"
											:rules="checkboxRules"
											:id="'form-researcher-affiliation-' + '5'"
											aria-describedby="form-researcher-affiliation-explanation-box"
										></v-checkbox>
										<!-- Input box if above checkbox is selected -->
										<div v-if="researcherAffiliation.includes(this.$createStudyLists.researcherAffiliations[5])">
											<br>
											<v-text-field
												v-model="researcherAffiliationClient"
												label="Specify Client"
												hide-details="auto"
												outlined
												aria-describedby="form-researcher-affiliation-explanation-box"
											></v-text-field>
										</div>
										<v-checkbox
											v-model="researcherAffiliation"
											:label="researcherAffiliationsCheckboxes[6]"
											:value="researcherAffiliationsCheckboxes[6]"
											:hide-details="false"
											:rules="checkboxRules"
											:id="'form-researcher-affiliation-' + '6'"
											aria-describedby="form-researcher-affiliation-explanation-box"
										></v-checkbox>
										<!-- Input box if above checkbox is selected -->
										<div v-if="researcherAffiliation.includes(this.$createStudyLists.researcherAffiliations[6])">
											<v-text-field
												v-model="researcherAffiliationOther"
												label="Other (specify)"
												hide-details="auto"
												outlined
												aria-describedby="form-researcher-affiliation-explanation-box"
												:aria-label="'Other (specify): ' + researcherAffiliationOther"
											></v-text-field>
										</div>
									</fieldset>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-researcher-affiliation-explanation-box"
										:fullBox=true
										:color="'green'"
										:displayText="'Select the entity(ies) conducting the research. Check all that apply.<br><br>The purpose of the study is collected for internal tracking purposes only and does not affect study administration.'">
									</explanation-box>
								</v-col>
							</v-row>
							<v-divider></v-divider>
							<v-card-actions>
								<v-btn
									text
									class="btn-default"
									@click="onOpenCancel()"
								>
									Cancel
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn
									v-show="this.$store.getters.getSelectedStudy && this.$store.getters.getSelectedStudy.currentStudyStatus.toLowerCase() === 'draft'"
									text
									class="btn-default"
									@click="clearDraftDialog = true"
								>
									Reset Fields to Blank
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn
									:loading="loadingSave"
									text
									class="btn-default"
									@click="checkForm1()"
								>
									Save and Continue
								</v-btn>
							</v-card-actions>
						</v-form>
					</v-card>
				</v-stepper-content>
				<!-- Step 2 -->
				<v-stepper-content step="2">
					<h2 class="d-sr-only">Specify Study Details</h2>
					<v-card class="card-create-step" outlined>
						<p>All sections on this page are required</p>
						<v-form
							ref="form2"
							v-model="valid2"
							lazy-validation
						>
							<v-row>
								<v-col xs="12" sm="12" md="6">
										<h3 class="left-align">Study tool:</h3>
											<v-row>
												<v-col>
													<p class="p2 left-align">
														In this step, select how your respondents will report their intake. Select Recall Study or Record Study below.
													</p>
													<v-radio-group
														v-model="studyTool"
														mandatory
														style="float:center"
														class="studyToolRadio"

													>
														<v-radio :value="this.$createStudyLists.studyTools[0].name" id="firstRadioBtn">
															<template v-slot:label>
																<div style="color: #000000DE"><strong>Recall</strong> study: Report food & drink consumed the previous day</div>
															</template>
														</v-radio>
														<v-radio :value="this.$createStudyLists.studyTools[1].name">
															<template v-slot:label>
																<div style="color: #000000DE"><strong>Record</strong> study: Report food & drink consumed in real time</div>
															</template>
														</v-radio>
													</v-radio-group>
													<p class="p2 left-align">
														If you’re not sure what to choose, start with a suggested study configuration. 										You can then customize the settings to suit your needs.
													</p>
													<v-btn text
														class="btn-default left-align"
														@click="onOpenTest"
														ref="secondFocus"

														style="margin-top: 0; float: left"
													>
														Suggested Study Configurations
													</v-btn>
												</v-col>
											</v-row>
										</v-col>
									<v-col xs="12" sm="12" md="6">
										<explanation-box
											:color="'red'"
											:fullBox=true
											:displayText="'A <b>recall</b> asks respondents to report all foods and drinks consumed the previous day from midnight to midnight or during the previous 24 hours prior to the time of login.<br><br>A <b>record</b> (also known as a food diary) asks respondents to report all foods and drinks consumed in real time.<br><br> <em> To learn more about 24-hour recalls and food records, visit NCI’s <a href=&quot;https://dietassessmentprimer.cancer.gov/&quot; target=&quot;_blank&quot;>Dietary Assessment Primer</a>. The Primer can help researchers choose the best dietary assessment approach for their research objectives. </em>'">
										</explanation-box>
									</v-col>
							</v-row>
							<v-divider inset></v-divider>
							<!-- Recall specific inputs -->
							<div class="tool-specific" v-if="studyTool === this.$createStudyLists.studyTools[0].name">
								<v-card-title class="study-tool-title">{{this.$createStudyLists.studyTools[0].name}} Settings</v-card-title>
								<v-row>
									<v-col md="2">
										<h3 class="left-align">Study type: (recall)</h3>
									</v-col>
									<v-col md="4">
										<fieldset class="border-0">
											<legend class="d-sr-only">
												Study type: (recall)
											</legend>
											<v-radio-group
												v-model="studyType"
												:rules="radioRules"
												id="form-study-type-1"
											>
												<v-radio
													v-for="(type, i) in this.$createStudyLists.recallStudyTypes"
													:key="type.key + i"
													:label="type.key"
													:value="type.value"
													aria-describedby="form-study-type-1-explanation-box"
												></v-radio>
											</v-radio-group>
										</fieldset>
									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-study-type-1-explanation-box"
											:color="'yellow'"
											:displayText="'<strong>Scheduled study:</strong> You specify the intake dates for each respondent. Respondents can only login to complete recalls on the scheduled reporting dates. Intake dates can be changed or deleted up until the date occurs.<br><br><strong>Unscheduled study:</strong> Respondents can login to ASA24 at any time until the maximum number of recalls (next field) is reached. Unscheduled recalls may be preferred in research, clinical or classroom settings due to the unpredictable nature of the visits/classes or in a study in which the researcher prefers more internal controls related to scheduling recalls.<br><br><strong>Intake date</strong> is the day foods and beverages are consumed.<br><br><strong>Reporting date</strong> is the day or days that respondents login into ASA24 to report their intake. This date is derived from the intake date, intake time frame, and time to complete the recall.'"
										></explanation-box>
									</v-col>
								</v-row>
								<v-divider inset></v-divider>
								<v-row>
									<v-col md="2">
										<h3 class="left-align"><label for="form-total-recalls-respondent">Total number of recalls per respondents:</label></h3>
									</v-col>
									<v-col md="4">
										<v-text-field
											v-model="totalRecallsRespondent"
											hide-details="auto"
											outlined
											:rules="requiredFieldRule"
											type="number"
											min="0"
											id="form-total-recalls-respondent"
											name="form-total-recalls-respondent"
											aria-describedby="form-total-recalls-respondent-explanation-box"
											:aria-label="'Total number of recalls per respondents:' + totalRecallsRespondent"
										></v-text-field>
									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-total-recalls-respondent-explanation-box"
											:color="'green'"
											:displayText="'Indicate the maximum number of recalls to be reported by each respondent. This number can be changed after the study has started.<br><br>Note: Unfinished or quit recalls count toward this total number.'"
										></explanation-box>
									</v-col>
								</v-row>
								<v-divider inset></v-divider>
								<v-row>
									<v-col md="2">
										<h3 class="left-align">Intake time frame:</h3>
									</v-col>
									<v-col md="4">
										<fieldset class="border-0">
											<legend class="d-sr-only">
												Intake time frame:
											</legend>
											<v-radio-group
												v-model="intakeTimeFrame"
												:rules="radioRules"
												id="form-intake-time"
											>
												<v-radio
													v-for="(timeFrame, i) in this.$createStudyLists.intakeTimeFrames"
													:key="timeFrame.key + i"
													:label="timeFrame.key"
													:value="timeFrame.key"
													aria-describedby="form-intake-time-explanation-box"
												></v-radio>
											</v-radio-group>
										</fieldset>
									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-intake-time-explanation-box"
											:color="'green'"
											:displayText="'<strong>Midnight to midnight of the previous day:</strong> The respondent is prompted to enter all foods and drinks consumed during the entire previous day. For example, a respondent prompted on Sunday June 2 to complete a recall will report all foods consumed from midnight Saturday June 1 to midnight of Sunday June 2.<br><br><strong>Last 24 hours:</strong> The respondent is prompted to enter all foods and drinks consumed during the last 24 hours, starting from the time of day that the respondent logs in. For example, if the respondent logs in at 2:00 p.m. Sunday June 2 the respondent is asked to report all foods and drinks consumed from 2:00 p.m. on Saturday, June 1, to 2:00 p.m. on Sunday, June 2. Note: Respondents must complete the recall by midnight of the day they login (by midnight on Sunday, June 2, in the example above).<br><br>All times are relative to a respondent’s time zone. A respondent can login at any point to start his/her recall.'"
										></explanation-box>
									</v-col>
								</v-row>
								<v-divider inset></v-divider>
								<v-row>
									<v-col md="2">
										<h3 class="left-align">Number of Logins Allowed:</h3>
									</v-col>
									<v-col md="4">
										<fieldset class="border-0">
											<legend class="d-sr-only">
												Number of Logins Allowed:
											</legend>
											<v-radio-group
												v-model="numLoginsAllowed"
												:rules="radioRules"
												id="form-num-logins"
											>
												<v-radio
													v-for="(loginAllowedItem, i) in this.$createStudyLists.loginsAllowedList"
													:key="loginAllowedItem + i"
													:label="loginAllowedItem"
													:value="loginAllowedItem"
													aria-describedby="form-num-logins-explanation-box"
												></v-radio>
											</v-radio-group>
										</fieldset>
									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-num-logins-explanation-box"
											:color="'green'"
											:displayText="'<strong>One login:</strong> Requires respondents to complete their recalls within a single login session. If respondents log out or time out, they will not be permitted to log back in to modify or complete their recall. This option may be preferable in classroom or clinic settings in which you want the recall to be completed before the respondent leaves.<br><br><strong>Multiple logins:</strong> Allows respondents to login multiple times to complete their recalls as long as the intake time frame is still open.'"
										></explanation-box>
									</v-col>
								</v-row>
								<v-divider inset></v-divider>
								<v-row>
									<v-col md="2">
										<h3 class="left-align">Time Provided to Complete Recall:</h3>
									</v-col>
									<v-col md="4">
										<fieldset class="border-0">
											<legend class="d-sr-only">
												Time Provided to Complete Recall:
											</legend>
											<v-radio-group
												v-model="timeToComplete"
												:rules="radioRules"
												id="form-time-to-complete"
												:disabled="intakeTimeFrame == this.$createStudyLists.INTAKE_24_HOURS.key"
											>
												<v-radio
													v-for="(timeToCompleteItem, i) in this.$createStudyLists.timeToCompleteList"
													:key="timeToCompleteItem + i"
													:label="timeToCompleteItem"
													:value="timeToCompleteItem"
													aria-describedby="form-time-to-complete-explanation-box"
												></v-radio>
											</v-radio-group>
										</fieldset>
									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-time-to-complete-explanation-box"
											:color="'red'"
											:displayText="'<strong>By midnight:</strong> For example, if a respondent is to report what they consumed Saturday, June 1, selecting &quot;By midnight&quot; allows the respondent to login any time between 12:01 am to 11:59 pm Sunday, June 2, to report intake for June 1. This option is more traditional for 24-hour recalls.<br><br><strong>By 8 am:</strong> Allows the Respondent to login any time between 12:01 am Sunday, June 2, until 8:00 am Monday, June 3 to report intake for June 1. This option gives 36-hours for recalls.<br><br>All times are relative to a respondent’s time zone.'"
										></explanation-box>
									</v-col>
								</v-row>
							</div>
							<!-- Record specific inputs -->
							<div class="tool-specific" v-else-if="studyTool === this.$createStudyLists.studyTools[1].name">
								<v-card-title class="study-tool-title">{{this.$createStudyLists.studyTools[1].name}} Settings</v-card-title>
								<v-row>
									<v-col md="2">
										<h3 class="left-align">Study type:</h3>
									</v-col>
									<v-col md="4">
										<fieldset class="border-0">
											<legend class="d-sr-only">
												Study type:
											</legend>
											<v-radio-group
												v-model="studyType"
												:rules="radioRules"
												id="form-study-type-2"
											>
												<v-radio
													v-for="(type, i) in this.$createStudyLists.recordStudyTypes"
													:key="type.value + i"
													:label="type.key"
													:value="type.value"
													aria-describedby="form-study-type-2-explanation-box"
												></v-radio>
											</v-radio-group>
										</fieldset>
									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-study-type-2-explanation-box"
											:color="'red'"
											:displayText="'<strong>Consecutive-day:</strong> Respondents complete food records for two or more consecutive days. A consecutive-day record will begin on the first day a respondent logs in and the subsequent two or more days.<br><br><strong>Single-day:</strong> Each respondent completes one or more records, each for one intake day. In the case of multiple single-day records, the intake days must be separated by at least one day. For consecutive intake days, choose a multiple-day record.'"
										></explanation-box>
									</v-col>
								</v-row>
								<v-divider inset></v-divider>
								<div v-if="studyType === this.$createStudyLists.RECORD_TYPE_CONSECUTIVE.value">
									<v-row>
										<v-col md="2">
											<h3 class="left-align"><label for="form-num-consecutive-days">Number of consecutive days:</label></h3>
										</v-col>
										<v-col md="4">
											<v-text-field
												v-model="numConsecutiveDays"
												hide-details="auto"
												outlined
												:rules="requiredFieldRule"
												type="number"
												min="0"
												id="form-num-consecutive-days"
												name="form-num-consecutive-days"
												aria-describedby="form-num-consecutive-days-explanation-box"
											></v-text-field>
										</v-col>
										<v-col md="6" cols="12">
											<explanation-box
												id="form-num-consecutive-days-explanation-box"
												:fullBox=true
												:color="'green'"
												:displayText="'The number of consecutive intake days you want to collect within each record. For example, 3 consecutive intake days in one record. Multiple consecutive-day records must have the same number of consecutive intake days within each record.'">
											</explanation-box>
										</v-col>
									</v-row>
									<v-divider inset></v-divider>
								</div>
								<v-row>
									<v-col md="2">
										<h3 class="left-align"><label for="form-num-records">Number of records:</label></h3>
									</v-col>
									<v-col md="4">
										<v-text-field
											v-model="numRecords"
											hide-details="auto"
											outlined
											:rules="requiredFieldRule"
											type="number"
											min="0"
											id="form-num-records"
											name="form-num-records"
											aria-describedby="form-num-records-explanation-box"
										></v-text-field>
									</v-col>
									<v-col md="6" cols="12">
										<explanation-box
											id="form-num-records-explanation-box"
											:color="'green'"
											:displayText="'A food record can be for a single-day or multiple consecutive-days. Using the examples below as reference, specify the maximum number of single-day or consecutive N-day records you want respondents to complete.<br><br><strong>Examples of 1 record:</strong><br>One single-day record<br>One consecutive 3-day record (for example: one consecutive 3-day record completed from June 1-3)<br><br><strong>Examples of 3 records:</strong><br>Three single-day records where each day is separated by at least 24 hours (For example: A single-day record is completed on June 1, July 5, and August 15)<br>Three, 3-consecutive intake day records, collecting a total of 9 intake days<br><br>Note: ASA24 does not enforce any start date requirements for records. Researchers are responsible for contacting respondents about when to complete records.'"
										></explanation-box>
									</v-col>
								</v-row>
							</div>
							<!-- Common questions for both study tools -->
							<v-row>
								<v-col md="2">
									<h3 class="left-align"><label for="form-version">ASA24 version:</label></h3>
								</v-col>
								<v-col md="4">
									<v-select
										:items="this.getActiveStudyVersions"
										item-text="versionName"
										item-value="versionId"
										outlined
										v-model="version"
										:rules="radioRules"
										id="form-version"
										aria-describedby="form-version-explanation-box"
										item-color="black"
										:aria-label="'ASA24 version: ' + version"
									></v-select>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-version-explanation-box"
										:fullBox=true
										:color="'red'"
										:displayText="'Select the respondent version.<br><br> Note: there are specialized versions for Canada and Australia. These versions have been modified to reflect the Canadian and Australian food supplies, respectively.'">
									</explanation-box>
								</v-col>
							</v-row>
							<v-divider inset></v-divider>
							<v-row>
								<v-col md="2">
									<h3 class="left-align"><label for="form-respondent-num">Number of respondents:</label></h3>
								</v-col>
								<v-col md="4">
									<v-text-field
										v-model="respondentNum"
										hide-details="auto"
										outlined
										:rules="requiredFieldRule"
										type="number"
										min="0"
										id="form-respondent-num"
										name="form-respondent-num"
										aria-describedby="form-respondent-num-explanation-box"
										:aria-label="'Number of respondents: ' + respondentNum"
									></v-text-field>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-respondent-num-explanation-box"
										:color="'green'"
										:displayText="'Estimate the number of unique study respondents who will complete at least one recall or record.'"
									></explanation-box>
								</v-col>
							</v-row>
							<v-divider inset></v-divider>
							<v-row>
								<v-col md="2">
									<h3 class="left-align">Study start date:</h3>
								</v-col>
								<v-col md="4">
									<v-menu class="dateMenu" v-model="startDateMenu" :close-on-content-click="false" offset-x tile allow-overflow>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="startDate"
												hide-details="auto"
												outlined
												:rules="startDateRules"
												type="date"
												id="form-start-date"
												name="form-start-date"
												aria-describedby="form-start-date-explanation-box"
												v-bind="attrs"
												v-on="on"
												@keydown.tab="startDateMenu = false;"
												:aria-label="'Study start date: ' + startDate"
											>
											</v-text-field>
										</template>
										<v-date-picker v-model="startDate" color="#42729B" style="margin: 0px; float: left" @input="startDateMenu = false"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-start-date-explanation-box"
										:color="'green'"
										:displayText="'This is the first date that respondents may log into the respondent website to complete a recall or record.'"
									></explanation-box>
								</v-col>
							</v-row>
							<v-divider inset></v-divider>
							<v-row>
								<v-col md="2">
									<h3 class="left-align"><label for="form-end-date">Study end date:</label></h3>
								</v-col>
								<v-col md="4">
									<v-menu class="dateMenu" v-model="endDateMenu" :close-on-content-click="false" offset-x tile allow-overflow>
										<template v-slot:activator="{ on, attrs }">
											<v-text-field
												v-model="endDate"
												hide-details="auto"
												outlined
												:rules="endDateRules"
												:disabled="startDate === ''"
												type="date"
												id="form-end-date"
												name="form-end-date"
												aria-describedby="form-end-date-explanation-box"
												v-bind="attrs"
												v-on="on"
												@keydown.tab='endDateMenu = false'
												:aria-label="'Study end date: ' + endDate"
											>
											</v-text-field>
										</template>
										<v-date-picker v-model="endDate" color="#42729B" style="margin: 0px; float: left" @input="endDateMenu = false"></v-date-picker>
									</v-menu>
								</v-col>
								<v-col md="6" cols="12">
									<explanation-box
										id="form-end-date-explanation-box"
										:fullBox=true
										:color="'green'"
										:displayText="'This is the last date that respondents may log into the respondent web site to complete a recall or record. This means that respondents will not be able to log into the respondent website after midnight (in the respondent’s time zone) on the study end date.'">
									</explanation-box>
								</v-col>
							</v-row>
						</v-form>
						<v-divider></v-divider>
						<v-card-actions>
							<v-btn
								text
								class="btn-default"
								@click="onOpenCancel()"
							>
								Cancel All
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn
								text
								class="btn-default"
								@click="e1--"
							>
								&lt; Back
							</v-btn>
							<v-btn
								:loading="loadingSave"
								text
								class="btn-default"
								@click="checkForm2()"
							>
								Save and Continue >
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-stepper-content>
				<!-- Step 3 -->
				<v-stepper-content step="3">
					<h2 class="d-sr-only">Select Optional Study Modules</h2>
					<v-card class="card-create-step" outlined>
						<div class="text-left createStudyStepperPageTitle">Select Optional Study Modules</div>
						<h3 class="h6 left-align p2">Check modules to enable/disable at any time during the study. All modules except the Respondent Nutrition Report may increase time to completion.</h3>
						<fieldset class="border-0">
							<legend class="d-sr-only">
								Check modules to enable/disable at any time during the study
							</legend>
							<div
								class="optional-module-step"
								v-for="(optionalModule, i) in this.$createStudyLists.optionalModules"
								:key="optionalModule.name + i"
							>
								<v-row v-if="isModuleAllowed(optionalModule.name)">
									<v-col md="3">
										<v-checkbox
											v-if="optionalModule.name == 'Respondent Nutrition Report'"
											v-model="optionalStudyModules"
											:label="optionalModule.name"
											:value="optionalModule.name"
											hide-details="auto"
											@change="rnrCheckbox"
											class="moduleCheckbox"
											:aria-describedby="'optionalModule-' + i + '-explanation-box'"
										></v-checkbox>
										<v-checkbox
											v-else
											v-model="optionalStudyModules"
											:label="optionalModule.name"
											:value="optionalModule.name"
											hide-details="auto"
											class="moduleCheckbox"
											:aria-describedby="'optionalModule-' + i + '-explanation-box'"
										></v-checkbox>
										<div v-show="displayRNRSettings(optionalModule.name)" class="rnr-options">
											<fieldset class="border-0">
												<legend class="d-sr-only">
													Respondent Nutrition Report
												</legend>
												<v-radio-group
													v-model="showRNR"
													:rules="radioRules"
												>
													<v-radio
														v-for="(optionRNR, i) in optionsRNR"
														:key="optionRNR + i"
														:label="optionRNR"
														:value="optionRNR"
														aria-describedby="optionalModule-4-explanation-box"
													></v-radio>
												</v-radio-group>
											</fieldset>
										</div>
									</v-col>
									<v-col md="9" cols="12">
										<explanation-box
											:id="'optionalModule-' + i + '-explanation-box'"
											:color="'green'"
											:displayText="optionalModule.htmlText"
										></explanation-box>
									</v-col>
								</v-row>
							</div>
						</fieldset>
						<v-divider></v-divider>
						<v-card-actions>
							<v-btn
								text
								class="btn-default"
								@click="onOpenCancel()"
							>
								Cancel All
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn
								text
								class="btn-default"
								@click="e1--"
							>
								&lt; Back
							</v-btn>
							<v-btn
								:loading="loadingSave"
								text
								class="btn-default"
								@click="check3()"
							>
								Save and Continue >
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-stepper-content>
				<!-- Step 4 -->
				<v-stepper-content step="4">
					<h2 class="d-sr-only">Summary of New Study</h2>
					<v-card class="card-create-step" outlined v-if="e1 === 4">
						<h3 class="h5 text-left createStudyStepperPageTitle">Review study settings</h3>
						<v-row>
							<v-col sm="8">
								<v-simple-table dense>
									<template v-slot:default>
										<thead>
											<tr>
												<th style="font-size:16px" class="text-left" scope="col">
													Field
												</th>
												<th style="font-size:16px" class="text-center" scope="col">
													Changeability
												</th>
												<th style="font-size:16px" class="text-left" scope="col">
													Data
												</th>
											</tr>
										</thead>
										<tbody>
											<tr tabindex="0" v-for="row in filteredTableRowList" :key="row.name" @keyup.enter="e1 = row.location, scrollTop()">
												<th role="link" scope="row" style="font-size:16px" class="left-align reviewTableRow" @click="e1 = row.location, scrollTop()">
													{{row.name}} <span class="d-sr-only">(Clicking this link will navigate back to {{row.name}}.)</span>
												</th>
												<td class="text-center">
													<v-icon :style="iconStyles" small :color="row.iconColor">{{row.icon}}</v-icon>
													<span class="d-sr-only">{{row.iconLabel}}</span>
												</td>
												<td style="font-size:16px" class="left-align" v-html="displayPropertyByName(row.inputVarName, row.fieldId)"></td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-col>
							<v-col sm="4">
								<v-card-text class="sidebar-callout">
									<div class="text-left changeabilityBoxTitle">Legend for Study Settings</div>
									<br>
									<p class="green-expl"><v-icon :style="iconStyles" color="#1c7f20">lock_open</v-icon>Can be changed later</p>
									<p class="yellow-expl"><v-icon :style="iconStyles" color="#be4800">warning</v-icon>Can be changed until respondent accounts are created</p>
									<p class="red-expl"><v-icon :style="iconStyles" color="#d32829">lock</v-icon>Cannot be changed after study is created</p>
								</v-card-text>
								<br>
								<!-- style="font-weight: bold; color: rgba(0,0,0,.6);" -->
								<ul>
									<li class="left-align createStudySummaryText">Select one of the field titles from the list to return to the page of that field.</li>
									<br>
									<li class="left-align createStudySummaryText">Select “Back” at the bottom of the page to return to the previous page.</li>
									<br>
									<li class="left-align createStudySummaryText">Select “Create Study” when finished. Button is activated once all required fields are completed.</li>
								</ul>
							</v-col>
						</v-row>
						<v-divider></v-divider>
						<v-card-actions>
							<v-btn
								text
								class="btn-default"
								@click="onOpenCancel()"
							>
								Cancel All
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn
								text
								class="btn-default"
								@click="e1--"
							>
								&lt; Back
							</v-btn>
							<v-btn
								:loading="loadingSave"
								text
								class="btn-default"
								@click="saveStudy(true, true);"
							>
								Save as Draft
							</v-btn>
							<v-btn
								:loading="loadingSave"
								:disabled="!isErrorListEmpty"
								text
								class="btn-default"
								@click="saveStudy(true, false)"
							>
								Create Study
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
		<!-- Cancel pop up -->
		<foe-dialog
      v-model="cancelDialog"
			:dialogW="cancelDialog"
			persistent
			max-width="600px"
			class="cancel-dialog"
		>
			<v-card class="cancel-confirm-card">
				<v-card-title>Cancel</v-card-title>
				<v-card-text>Are you sure you want to cancel?</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						class="btn-default"
						@click="cancelDialog = false"
					>
						No
					</v-btn>
					<v-btn
						text
						class="btn-default"
						@click="onCancel()"
					>
						Yes
					</v-btn>
				</v-card-actions>
			</v-card>
		</foe-dialog>
		<!-- Suggestions pop up -->
		<foe-dialog
			v-model="suggestionsDialog"
			:dialogW="suggestionsDialog"
			scrollable
			max-width="900px"
			class="suggestions-dialog"
		>
			<v-card>
				<v-card-title class="justify-center black--text">Suggested Study Configurations</v-card-title>
				<v-br></v-br>
				<v-card-subtitle class="text-left black--text">Select an optional study configuration to get started.  You can then customize these settings to meet your research needs.</v-card-subtitle>
				<v-divider></v-divider>
				<v-card-text style="height: 470px;">
					<fieldset class="border-0">
						<legend class="d-sr-only">
							Suggested Study Configurations
						</legend>
						<v-radio-group
							v-model="suggestedStudyConfig"
							column
						>
							<v-row>
								<v-col cols="1">
									<v-radio value="URS" id="ssc1"></v-radio>
								</v-col>
								<v-col cols="11">
									<div>
										<label for="ssc1"><strong class="black--text">Unscheduled Recall study.</strong> Each respondent is assigned a maximum of 4 recalls that can be completed at any time within the study period. Once logged in, respondents will report their intake for yesterday (relative to first login date) from midnight to midnight.  The respondent will be allowed to login multiple times during the reporting day up until midnight to complete their recalls.</label>
									</div>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="1">
									<v-radio value="SRS" id="ssc2"></v-radio>
								</v-col>
								<v-col cols="11">
									<div>
										<label for="ssc2"><strong class="black--text">Scheduled Recall study.</strong> Each respondent is assigned a specific intake date for 3 recalls. Respondents will only be allowed to log in to the respondent website on the reporting dates corresponding to these intake dates.  Once logged in, respondents will report their intake for yesterday (relative to assigned date) from midnight to midnight.  The respondent will be allowed to login multiple times during the reporting day up until midnight to complete their recalls.</label>
									</div>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="1">
									<v-radio value="3dCDRS" id="ssc3"></v-radio>
								</v-col>
								<v-col cols="11">
									<div>
										<label for="ssc3"><strong class="black--text">3 day consecutive-day Record study.</strong> Each respondent completes 3 consecutive intake days within one record.</label>
									</div>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="1">
									<v-radio value="SDRS" id="ssc4"></v-radio>
								</v-col>
								<v-col cols="11">
									<div>
										<label for="ssc4"><strong class="black--text">Single-day Record study.</strong> Each respondent completes one intake day in a record.</label>
									</div>
								</v-col>
							</v-row>
						</v-radio-group>
					</fieldset>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions class="text-right">
					<v-row>
						<v-col><p class="text-left">Related: View <a target="_blank" href="https://dietassessmentprimer.cancer.gov/" aria-label="Dietary Assessment Primer - New Window">Dietary Assessment Primer</a> in new window</p></v-col>
						<v-col>
							<v-btn
								text
								class="btn-default"
								@click="suggestionsDialog = false"
							>
								Cancel
							</v-btn>
							<v-btn
								text
								class="btn-default"
								@click="suggestionsDialog = false; applyConfiguration()"
							>
								Apply Configuration
							</v-btn>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</foe-dialog>
		<!-- Clear fields dialog -->
		<foe-dialog
			v-model="clearDraftDialog"
			:dialogW="clearDraftDialog"
			max-width="600"
			class="clear-draft-dialog"
		>
			<v-card class="draft-delete-confirm-card">
				<v-toolbar
					dark
					color="primary"
				>
					<v-toolbar-title>Save Changes</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn
						icon
						dark
						@click="clearDraftDialog = false"
					>
						<v-icon>close</v-icon>
					</v-btn>
				</v-toolbar>
				<br>
				<v-card-text>
					<p class="p2 left-align">
						Please confirm you want to blank out the New Study form. This will reset the fields in all three steps.
					</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						text
						class="btn-default"
						@click="clearDraftDialog = false"
					>
						Cancel
					</v-btn>
					<v-btn
						text
						class="btn-default"
						@click="deleteDraft()"
					>
						Reset Fields
					</v-btn>
				</v-card-actions>
			</v-card>
		</foe-dialog>
	</div>
</template>

<script>
import { researcherApiService } from '@/services/researcherApiService';
import { moduleService } from '@/services/moduleService';
import { Roles } from '@/common/Roles.js';
export default {
	name: 'CreateStudyPage',
	props: {
	},
	metaInfo: {
		title: 'Create Study'
	},
	data: () => ({
		// Step 1 properties
		studyName: '',
		studyDescription: '',
		studyCharacteristics: [],
		studyAbbreviation: '',
		isAbbreviationValid: true,
		abbrevitionSuggestions: [],
		selectedSuggestion: '',
		studyPurpose: '',
		studyPurposeOther: '',
		researchType: [],
		researchTypeOther: '',
		fundsReceived: '',
		fundsReceivedOther: '',
		fundingSource: [],
		fundingSourceNIHOther: '',
		fundingSourceAgencyOther: '',
		fundingSourceOther: '',
		contractNum: '',
		openSubFunds: false,
		openAgencies: false,
		researcherAffiliation: [],
		studyNameRules: [
			v => v !== '' || 'This section is required',
			v => (v && v.length <= 40) || 'Max 40 characters'
		],
		studyDescriptionRules: [
			v => v !== '' || 'This section is required',
			v => (v && v.length <= 400) || 'Max 400 characters'
		],
		studyAbbreviationRules: [
			v => (v && v.length >= 3) || 'Min 3 characters',
			v => (v && v.length <= 8) || 'Max 8 characters',
			v => /^[a-zA-Z]*$/.test(v) || 'No numbers or special characters allowed'
		],
		researchTypeCheckboxes: [],
		studyCharacteristicsCheckboxes: [],
		fundingSourcesCheckboxes: [],
		researcherAffiliationsCheckboxes: [],
		researcherAffiliationOther: '',
		researcherAffiliationAgency: '',
		researcherAffiliationOrganization: '',
		researcherAffiliationClient: '',
		// Step 2 properties
		studyTool: '',
		studyType: '',
		version: '',
		respondentNum: '',
		startDate: '',
		endDate: '',
		todayDate: '',
		startDateRules: [
			v => v !== '' || 'Improper date or missing value(s)'
		],
		endDateRules: [
			v => v !== '' || 'Improper date or missing value(s)'
		],
		// Step 2 recall properties
		totalRecallsRespondent: '',
		intakeTimeFrame: '',
		numLoginsAllowed: '',
		timeToComplete: '',
		// Step 2 record properties
		numConsecutiveDays: '',
		numRecords: '',
		// Step 3 properties
		optionalStudyModules: ['Location'],
		showRNR: 'Do not display at the end of the recall',
		rnrToggle: 0,
		// Shared properties
		radioRules: [v => ((v && v !== '') || 'This section is required')],
		checkboxRules: [v => ((v && v.length > 0) || 'This section is required')],
		requiredFieldRule: [v => (v && v.length > 0) || 'This section is required'],
		valid1: true,
		valid2: true,
		valid3: true,
		validAbbreviation: true,
		tableRowList: [],
		loadingSave: false,
		studyUuid: '',
		e1: 1,
		errorListSummary: [],
		cancelDialog: false,
		clearDraftDialog: false,
		suggestionsDialog: false,
		iconStyles: {
			fontSize: '22px'
		},
		suggestedStudyConfig: '',
		dialog: false,
		startDateMenu: false,
		endDateMenu: false
	}),
	beforeUpdate: function () {
		// if (this.optionalStudyModules.includes('Respondent Nutrition Report')) {
		// 	this.showRNR = 'Display at the end of the recall'
		// }
		// if (!this.optionalStudyModules.includes('Respondent Nutrition Report')) {
		// 	this.showRNR = 'Do not display at the end of the recall'
		// }
	//
		if (this.optionalStudyModules.includes('Source') && !this.optionalStudyModules.includes('Location')) {
			this.optionalStudyModules.push('Location')
		}
	},
	updated: function () {
		var completeSteps = document.getElementsByClassName('v-stepper__step--complete')
		for (const stepHead of completeSteps) {
			stepHead.setAttribute('aria-label', stepHead.innerText);
		}
	},
	mounted: function () {
		// Page does not load at the top of the page depending on the scroll position of the
		// previous page
		this.scrollTop();
		// Checkbox input lists must be copied in order to be able to use array functions
		this.researchTypeCheckboxes = this.$createStudyLists.researchTypes;
		this.fundingSourcesCheckboxes = this.$createStudyLists.fundingSources;
		this.researcherAffiliationsCheckboxes = this.$createStudyLists.researcherAffiliations;
		this.studyCharacteristicsCheckboxes = this.$createStudyLists.studyCharacteristics;
		this.tableRowList = this.$createStudyLists.tableRowList;
		this.researcherAffiliation = [];
		this.$refs.form1.resetValidation()

		var date = new Date();
		var month = '';
		var day = '';

		if ((date.getMonth() + 1) < 10) {
			month = '0' + (date.getMonth() + 1);
		} else {
			month = date.getMonth() + 1
		}

		if (date.getDate() < 10) {
			day = '0' + date.getDate();
		} else {
			day = date.getDate();
		}

		this.todayDate = date.getFullYear() + '-' + month + '-' + day;

		var draftStudy = this.$store.getters.getSelectedStudy;

		// This rule needs to be added after data variables are created
		this.studyAbbreviationRules.push(v => this.isAbbreviationValid || 'Abbreviation already taken');

		// This checks for a draft study that needs to be loaded
		if (draftStudy && draftStudy.currentStudyStatus.toLowerCase() === 'draft') {
			this.studyUuid = draftStudy.studyUuid;
			this.studyName = draftStudy.studyName;
			this.studyDescription = draftStudy.description;
			this.studyAbbreviation = draftStudy.studyId;
			this.fundsReceived = JSON.parse(draftStudy.funding).selection;
			this.fundsReceivedOther = JSON.parse(draftStudy.funding).otherText;
			this.contractNum = draftStudy.grantContractNumber;

			this.studyCharacteristics = JSON.parse(draftStudy.studyCharacteristics);

			var studyPurpose = JSON.parse(draftStudy.purposeType);
			this.studyPurpose = studyPurpose.selection;
			if (this.studyPurpose === this.$createStudyLists.studyPurposes[4]) {
				this.studyPurposeOther = studyPurpose.value;
			}

			var researchType = [];
			researchType = JSON.parse(draftStudy.researchType);
			for (var i = 0; i < researchType.length; i++) {
				this.researchType.push(researchType[i].selection);
				if (researchType[i].selection === this.$createStudyLists.researchTypes[5]) {
					this.researchTypeOther = researchType[i].value;
				}
			}

			var fundingSource = [];
			this.fundingSource = [];
			fundingSource = JSON.parse(draftStudy.funding).listOfFunds;
			for (var j = 0; j < fundingSource.length; j++) {
				this.fundingSource.push(fundingSource[j].selection);

				// If any of the NIH options are selected, the higher level NIH checkbox must be selected
				if (fundingSource[j].value.includes('NIH')) {
					this.openSubFunds = true;
				}

				if (fundingSource[j].value.includes('Other US Government Agency')) {
					this.openAgencies = true;
				}

				if (fundingSource[j].selection === this.$createStudyLists.fundingSources[0].subCategories[5].alias) {
					this.fundingSourceNIHOther = fundingSource[j].value;
				} else if (this.fundingSource[j] === this.$createStudyLists.fundingSources[1].subCategories[4].alias) {
					this.fundingSourceAgencyOther = fundingSource[j].value;
				} else if (this.fundingSource[j] === this.$createStudyLists.fundingSources[2].name) {
					this.fundingSourceOther = fundingSource[j].value;
				}
			}

			var affiliation = [];
			this.researcherAffiliation = [];
			affiliation = JSON.parse(draftStudy.organizationType);
			for (var k = 0; k < affiliation.length; k++) {
				this.researcherAffiliation.push(affiliation[k].selection);
				if (affiliation[k].selection === this.$createStudyLists.researcherAffiliations[1]) {
					this.researcherAffiliationAgency = affiliation[k].value;
				} else if (affiliation[k].selection === this.$createStudyLists.researcherAffiliations[4]) {
					this.researcherAffiliationOrganization = affiliation[k].value;
				} else if (affiliation[k].selection === this.$createStudyLists.researcherAffiliations[5]) {
					this.researcherAffiliationClient = affiliation[k].value;
				} else if (affiliation[k].selection === this.$createStudyLists.researcherAffiliations[6]) {
					this.researcherAffiliationOther = affiliation[k].value;
				}
			}

			// Recall studyTool is the default choice
			this.studyTool = (draftStudy.studyTool === this.$createStudyLists.STUDY_TOOL_RECORD.value ? this.$createStudyLists.studyTools[1].name : this.$createStudyLists.studyTools[0].name);

			// If the variables are set with empty or null values, it triggers the validation
			if (draftStudy.version && draftStudy.version !== '') {
				this.version = draftStudy.version;
			}

			this.respondentNum = draftStudy.numParticipants.toString() !== '0' ? draftStudy.numParticipants.toString() : '';

			// If dates very empty when saved as a draft, they get set to 1970-01-01.
			// Don't load dates from draft study if they were empty before.
			// // (CHT comment out below because if was breaking the dates menu when opening a drafted study; would like confirmation before deleting)
			// if (draftStudy.dateStart !== '1970-01-01') {
			// 	this.startDate = draftStudy.dateStart;
			// }

			// if (draftStudy.dateEnd !== '1970-01-01') {
			// 	this.endDate = draftStudy.dateEnd;
			// }

			this.studyType = (draftStudy.studyTool === this.$createStudyLists.STUDY_TOOL_RECORD.value ? draftStudy.recordStudyType : draftStudy.recallType);

			// Only set the variables from the chosen study tool, don't set '0' values.
			if (this.studyTool === this.$createStudyLists.studyTools[0].name) {
				this.totalRecallsRespondent = draftStudy.numRecallsPerParticipant.toString() !== '0' ? draftStudy.numRecallsPerParticipant.toString() : '';
				this.timeToComplete = (draftStudy.numberHoursToComplete === '0' ? '' : (draftStudy.numberHoursToComplete === '24' ? this.$createStudyLists.timeToCompleteList[0] : this.$createStudyLists.timeToCompleteList[1]))

				if (draftStudy.midnightTimeFrame !== 'false') {
					this.intakeTimeFrame = this.$createStudyLists.INTAKE_MIDNIGHT_TO_MIDNIGHT.key;
				} else if (draftStudy.recallType !== '') {
					this.intakeTimeFrame = this.$createStudyLists.INTAKE_24_HOURS.key;
				}

				if (draftStudy.multipleSessions !== 'false') {
					this.numLoginsAllowed = this.$createStudyLists.loginsAllowedList[1];
				} else if (draftStudy.recallType !== '') {
					this.numLoginsAllowed = this.$createStudyLists.loginsAllowedList[0];
				}
			} else if (this.studyTool === this.$createStudyLists.studyTools[1].name) {
				this.numConsecutiveDays = draftStudy.numConsecutiveRecordDays.toString() !== '0' ? draftStudy.numConsecutiveRecordDays.toString() : '';
				this.numRecords = draftStudy.numRecordsPerParticipant.toString() !== '0' ? draftStudy.numRecordsPerParticipant.toString() : '';
			}

			if (draftStudy.tvModule === 'true' && !this.optionalStudyModules.includes(this.$createStudyLists.optionalModules[3].name)) {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[3].name);
			}
			if (draftStudy.supplementModule === 'true' && !this.optionalStudyModules.includes(this.$createStudyLists.optionalModules[6].name)) {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[6].name);
			}
			if (draftStudy.sourceModule === 'true' && !this.optionalStudyModules.includes(this.$createStudyLists.optionalModules[2].name)) {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[2].name);
			}

			if (draftStudy.locationModule === 'true' && !this.optionalStudyModules.includes(this.$createStudyLists.optionalModules[0].name)) {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[0].name);
			} else if (draftStudy.locationModule === 'false') {
				const index = this.optionalStudyModules.indexOf('Location');
				if (index > -1) {
					this.optionalStudyModules.splice(index, 1);
				}
			}
			if ((draftStudy.nutritionProfileModule === 'true' || draftStudy.nutritionProfileModule === true) && !this.optionalStudyModules.includes(this.$createStudyLists.optionalModules[4].name)) {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[4].name);
			}

			if (draftStudy.eatWithModule === 'true' && !this.optionalStudyModules.includes(this.$createStudyLists.optionalModules[1].name)) {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[1].name);
			}

			if (draftStudy.sleepModule === 'true' && !this.optionalStudyModules.includes(this.$createStudyLists.optionalModules[5].name)) {
				this.optionalStudyModules.push(this.$createStudyLists.optionalModules[5].name);
			}
		}

		this.$nextTick(function () {
			// 2021.10.20 - Sebastian Calle assisted with the following idea/solution
			// Code that will run only after the entire view has been rendered
			// var b = document.getElementById('form-study-purpose');
			// b.setAttribute('aria-labelledby', 'form-study-purpose-label')

			// 2021.10.25 - Yevgeniy editted above to target class name and remove aria-labelledby attribute for all elements

			var vRadioGroup = document.getElementsByClassName('v-input--radio-group__input');
			for (let i = 0; i < vRadioGroup.length; i++) {
				vRadioGroup[i].removeAttribute('aria-labelledby');
			}
			// adding focus to stop element on start
			this.$refs.firstFocus.focus()
		});
	},
	watch: {
		openSubFunds: function (val) {
			if (val === false) {
				this.contractNum = '';
				for (var i = 0; i < this.fundingSourcesCheckboxes[0].subCategories.length; i++) {
					const index = this.fundingSource.indexOf(this.fundingSourcesCheckboxes[0].subCategories[i].alias);
					if (index > -1) {
						this.fundingSource.splice(index, 1);
					}
				}
			}
		},
		fundsReceived: function (val) {
			if (val !== this.$createStudyLists.FUNDS_YES.key) {
				this.fundingSource = [];
				this.fundingSourceOther = '';
				this.fundingSourceNIHOther = '';
				this.fundingSourceAgencyOther = '';
				this.contractNum = '';
				this.openSubFunds = false;
				this.openAgencies = false;
			}
		},
		studyPurpose: function (newVal, oldVal) {
			// If the value changes from research, all values that depend on that selection should be reset
			if (newVal !== this.$createStudyLists.studyPurposes[0] && oldVal === this.$createStudyLists.studyPurposes[0]) {
				this.researchType = [];
				this.fundsReceived = '';
				this.fundsReceivedOther = '';
				this.fundingSource = [];
				this.fundingSourceOther = '';
				this.fundingSourceNIHOther = '';
				this.fundingSourceAgencyOther = '';
				this.openSubFunds = false;
				this.openAgencies = false;
				this.contractNum = '';
				this.researchTypeOther = '';
			}

			// If the 'other' option is unselected, the other field should be reset to no value
			if (oldVal === this.$createStudyLists.studyPurposes[4]) {
				this.studyPurposeOther = '';
			}
		},
		studyTool: function (newVal, oldVal) {
			// & this.suggestedStudyConfig === ''
			if (newVal && oldVal) {
				if (oldVal === this.$createStudyLists.studyTools[0].name) {
					// Values that work with recall study must be reset
					this.resetRecallValues();
				} else if (oldVal === this.$createStudyLists.studyTools[1].name) {
					// Values that work with record study must be reset
					this.resetRecordValues();
				}

				if (newVal === this.$createStudyLists.studyTools[1].name) {
					// When choosing record default the intake time frame to midnight to midnight
					this.intakeTimeFrame = this.$createStudyLists.INTAKE_MIDNIGHT_TO_MIDNIGHT.key;
					// Default allowed logins to multiple
					this.numLoginsAllowed = this.$createStudyLists.loginsAllowedList[1];
				}
			}

			this.$nextTick(function () {
				var vRadioGroup = document.getElementsByClassName('v-input--radio-group__input');
				for (let i = 0; i < vRadioGroup.length; i++) {
					vRadioGroup[i].removeAttribute('aria-labelledby');
				}
			})
		},
		studyType: function (newVal, oldVal) {
			if (oldVal && oldVal === this.$createStudyLists.RECORD_TYPE_CONSECUTIVE.value) {
				this.numConsecutiveDays = '';
			}
		},
		researchType: function (newVal, oldVal) {
			if (oldVal && oldVal.includes(this.$createStudyLists.researchTypes[5]) && !newVal.includes(this.$createStudyLists.researchTypes[5])) {
				this.researchTypeOther = '';
			}
		},
		fundingSource: function (newVal, oldVal) {
			if (oldVal && oldVal.includes(this.$createStudyLists.fundingSources[2].name) && !newVal.includes(this.$createStudyLists.fundingSources[2].name)) {
				this.fundingSourceOther = '';
			}

			if (oldVal && oldVal.includes(this.$createStudyLists.fundingSources[0].subCategories[5].alias) && !newVal.includes(this.$createStudyLists.fundingSources[0].subCategories[5].alias)) {
				this.fundingSourceNIHOther = '';
			}

			if (oldVal && oldVal.includes(this.$createStudyLists.fundingSources[1].subCategories[4].alias) && !newVal.includes(this.$createStudyLists.fundingSources[1].subCategories[4].alias)) {
				this.fundingSourceAgencyOther = '';
			}
		},
		researcherAffiliation: function (newVal, oldVal) {
			if (oldVal && oldVal.includes(this.$createStudyLists.researcherAffiliations[1]) && !newVal.includes(this.$createStudyLists.researcherAffiliations[1])) {
				this.researcherAffiliationAgency = '';
			} else if (oldVal && oldVal.includes(this.$createStudyLists.researcherAffiliations[4]) && !newVal.includes(this.$createStudyLists.researcherAffiliations[4])) {
				this.researcherAffiliationOrganization = '';
			} else if (oldVal && oldVal.includes(this.$createStudyLists.researcherAffiliations[5]) && !newVal.includes(this.$createStudyLists.researcherAffiliations[5])) {
				this.researcherAffiliationClient = '';
			} else if (oldVal && oldVal.includes(this.$createStudyLists.researcherAffiliations[6]) && !newVal.includes(this.$createStudyLists.researcherAffiliations[6])) {
				this.researcherAffiliationOther = '';
			}
		},
		studyAbbreviation: function (val) {
			this.validateAbbreviation(val);
		},
		selectedSuggestion: function (val) {
			if (val !== '') {
				this.studyAbbreviation = val;
			}
		},
		intakeTimeFrame: function (val) {
			if (val && val === this.$createStudyLists.INTAKE_24_HOURS.key) {
				this.timeToComplete = this.$createStudyLists.timeToCompleteList[0];
			}
		},
		displayRNRSettings: function (newVal, oldVal) {
			this.$nextTick(function () {
				var vRadioGroup = document.getElementsByClassName('v-input--radio-group__input');
				for (var i = 0; i < vRadioGroup.length; i++) {
					vRadioGroup[i].removeAttribute('aria-labelledby');
				}
			});
		}
	},
	methods: {
		scrollTop () {
			window.scrollTo(0, 0);
		},
		validateAbbreviation (val) {
			const me = this;

			if (val && val.length > 2 && val.length < 9 && /^[a-zA-Z]*$/.test(val)) {
				researcherApiService.checkAbbreviation(val)
					.then(function (response) {
						if (response && response.data) {
							if (response.data.status.toUpperCase() === 'VALID') {
								me.isAbbreviationValid = true;
							} else if (response.data.status.toUpperCase() === 'INVALID') {
								console.log('invalid');
								me.isAbbreviationValid = false;
								me.abbrevitionSuggestions = response.data.suggestions;
							}
						}
						me.$refs.formAbbreviation.validate();
					})
					.catch(function (e) {
						console.log(e);
					});
			}
		},
		resetRecallValues () {
			// this.studyType = ''; // cht- took out to fix study suggestions error
			this.totalRecallsRespondent = '';
			this.intakeTimeFrame = '';
			this.numLoginsAllowed = '';
			this.timeToComplete = '';
			this.$refs.form2.resetValidation()
		},
		resetRecordValues () {
			// this.studyType = ''; // cht- took out to fix study suggestions error
			this.numConsecutiveDays = '';
			this.intakeTimeFrame = '';
			this.numLoginsAllowed = '';
			this.numRecords = '';
			this.$refs.form2.resetValidation()
		},
		onOpenCancel () {
			this.cancelDialog = true;
		},
		onOpenTest () {
			this.suggestionsDialog = true;
		},
		onCancel () {
			this.$router.push('/landing');
		},
		async checkForm1 () {
			// Show the spinner on the save button
			this.loadingSave = true;

			// Validate and save the study as a draft
			this.checkExtraDateRules();
			await this.saveStudy(false, true);

			// Move to the next step, scroll to the top, and turn off the save button spinner
			this.e1++;
			this.scrollTop();
			this.loadingSave = false;
		},
		async checkForm2 () {
			// Show the spinner on the save button
			this.loadingSave = true;

			// Save the study as a draft
			await this.saveStudy(false, true);

			// Move to the next step, scroll to the top, and turn off the save button spinner
			this.e1++;
			this.scrollTop();
			this.loadingSave = false;
		},
		async check3 () {
			// Show the spinner on the save button
			this.loadingSave = true;

			// Validate the forms
			this.$refs.form1.validate();
			this.$refs.form2.validate();

			// clear error list
			this.errorListSummary = [];

			// Save errors for first step
			for (var i = 0; i < this.$refs.form1.inputs.length; i++) {
				if (!this.$refs.form1.inputs[i].valid) {
					if (((typeof this.$refs.form1.inputs[i].hideDetails) === 'boolean' && this.$refs.form1.inputs[i].hideDetails === false) || (typeof this.$refs.form1.inputs[i].hideDetails) === 'string') {
						this.errorListSummary.push({ fieldId: this.$refs.form1.inputs[i].id, message: this.$refs.form1.inputs[i].validations[0] });
					}
				}
			}

			// include formAbbreviation input which exists in its own form on first step
			if (!this.$refs.formAbbreviation.inputs[0].valid) {
				if (((typeof this.$refs.formAbbreviation.inputs[0].hideDetails) === 'boolean' && this.$refs.formAbbreviation.inputs[0].hideDetails === false) || (typeof this.$refs.formAbbreviation.inputs[0].hideDetails) === 'string') {
					this.errorListSummary.push({ fieldId: this.$refs.formAbbreviation.inputs[0].id, message: this.$refs.formAbbreviation.inputs[0].validations[0] });
				}
			}

			// Save errors for second step
			for (var j = 0; j < this.$refs.form2.inputs.length; j++) {
				if (!this.$refs.form2.inputs[j].valid) {
					if (((typeof this.$refs.form2.inputs[j].hideDetails) === 'boolean' && this.$refs.form2.inputs[j].hideDetails === false) || (typeof this.$refs.form2.inputs[j].hideDetails) === 'string') {
						this.errorListSummary.push({ fieldId: this.$refs.form2.inputs[j].id, message: this.$refs.form2.inputs[j].validations[0] });
					}
				}
			}

			await this.saveStudy(false, true);

			// This function is used by goTo4() to validate and add errors for summary page.
			// e1 must be set to 4 instead of using ++
			this.e1 = 4;
			this.scrollTop();
		},
		goTo1 () {
			this.saveStudy(false, true);
			this.e1 = 1;
			this.scrollTop();
			this.focusOnNum(1)
		},
		goTo2 () {
			this.checkExtraDateRules();
			this.saveStudy(false, true);
			this.e1 = 2;
			this.scrollTop();
			this.focusOnNum(2)
		},
		goTo3 () {
			this.checkExtraDateRules();
			this.saveStudy(false, true);
			this.e1 = 3;
			this.scrollTop();
		},
		goTo4 () {
			this.checkExtraDateRules();
			// When going to the summary page we need to run validations and add the errors to the summary page.
			// The function check3() takes care of validation and saving the current draft study.
			this.check3();
		},
		focusOnNum (num) {
			console.log('focusOnNum: ', num)
			var name
			if (num === 1) {
				name = this.$refs.firstFocus
			}
			if (num === 2) {
				name = document.getElementById('firstRadioBtn')
			}
			this.$nextTick(function () {
				console.log('nextTick: ', name)
				name.focus()
			})
		},
		checkExtraDateRules () {
			if (this.startDateRules.length === 1) {
				this.startDateRules.push(v => v >= this.todayDate || 'Date must be greater than or equal to today');
				this.endDateRules.push(v => v > this.todayDate || 'Date must be greater than today');
				this.endDateRules.push(v => v > this.startDate || 'Date must be greater than the start date');
			}
		},
		displayPropertyByName (varName, fieldName) {
			// Displays an error instead if there is one
			for (var i = 0; i < this.errorListSummary.length; i++) {
				if (this.errorListSummary[i].fieldId.includes(fieldName)) {
					var messageHtml = '<span class="summary-error">' + this.errorListSummary[i].message + '</span>';
					return (messageHtml);
				}
			}

			if (varName === 'version') {
				var versionText = ''
				var versionNumber = this[varName]
				var versionObjectList = this.$store.getters.getActiveStudyVersions
				for (var piece of versionObjectList) {
					if (versionNumber === piece.versionId) {
						versionText = piece.versionName
					}
				}
				return versionText
			} else if ((typeof this[varName]) === 'object') {
				var filteredArrayStr = String(this[varName]).replace(/,/g, ', ');
				filteredArrayStr = filteredArrayStr.replace(/_/g, ' ');
				return filteredArrayStr;
			} else {
				return this[varName];
			}
		},
		displayRNRSettings (currentModule) {
			const moduleRnr = moduleService.isModuleRNRAllowed(this.version, this.studyType);
			const isRnrModule = currentModule === 'Respondent Nutrition Report';
			const isRnrChecked = this.optionalStudyModules.some(element => element === 'Respondent Nutrition Report');

			return isRnrModule && isRnrChecked && moduleRnr.isModuleAllowed && moduleRnr.isFollowupAllowed;
		},
		async saveStudy (isLastStep, isDraft) {
			this.loadingSave = true;
			var tempStudy = this.newStudy;
			if (isLastStep && !isDraft) {
				tempStudy.currentStudyStatus = 'Created';
			} else {
				tempStudy.currentStudyStatus = 'Draft';
			}

			// Any fields backed by an enum in the API need to be null rather than empty string when they have no value
			if (tempStudy.recallType === '') {
				tempStudy.recallType = null;
			}
			if (tempStudy.recordType === '') {
				tempStudy.recordType = null;
			}

			const me = this;
			let isSaved = false;
			await this.$store.dispatch('createStudy', tempStudy)
				.then(async function (response) {
					console.log('saveStudy', response);
					if (response && response.study) {
						me.studyUuid = response.study[0].studyUuid;
						if (isLastStep && !isDraft) {
							me.$store.dispatch('changeUpdateStatus', { status: 'new-study' });
						} else if (isLastStep && isDraft) {
							me.$store.dispatch('changeUpdateStatus', { status: 'new-study-draft' })
						}
						isSaved = true;
						return Promise.resolve;
					} else {
						const errorMessage = 'There was an error saving the study. Please try again or contact the help desk.';
						me.$store.dispatch('changeUpdateStatusWithMessage', { status: 'generic-error', message: errorMessage });
						return Promise.reject;
					}
				});
			this.loadingSave = false;
			var studyRole = {
				studyUuid: this.studyUuid,
				studyId: this.studyAbbreviation,
				role: Roles.Researcher
			}
			this.$store.dispatch('saveStudyUserInfo', studyRole);

			if (isLastStep && isSaved) {
				this.$router.push('/landing');
			}
			return Promise.resolve;
		},
		deleteDraft () {
			const me = this;
			this.$store.dispatch('deleteStudy', this.studyUuid)
				.then(function (response) {
					if (response) {
						me.$store.dispatch('changeUpdateStatus', { status: 'deleted-study-draft' });
						me.clearDraftDialog = false;
						me.$store.commit('deleteSelectedStudyUuid');
						me.$router.push('/landing');
					} else {
						console.log('delete failed');
					}
				});
		},
		rnrCheckbox () {
			const check = this.rnrToggle
			if (check === 0) {
				this.rnrToggle = 1
				this.showRNR = 'Display at the end of the recall'
			} else if (check === 1) {
				this.rnrToggle = 0
				this.showRNR = 'Do not display at the end of the recall'
			}
		},
		convertShowRNR (showRNR) {
			let nutritionProfileModuleShowReportBoolean = false;
			if (showRNR === 'Display at the end of the recall') {
				nutritionProfileModuleShowReportBoolean = true
			} else if (showRNR === 'Do not display at the end of the recall') {
				nutritionProfileModuleShowReportBoolean = false
			}
			return nutritionProfileModuleShowReportBoolean
		},
		applyConfiguration () {
			const me = this
			switch (me.suggestedStudyConfig) {
			case 'URS':
				me.studyTool = ''
				me.studyType = '';
				me.numConsecutiveDays = '';
				me.numRecords = '';
				me.studyTool = 'RECALL STUDY'
				me.studyType = 'UNSCHEDULED'
				me.totalRecallsRespondent = '4'
				me.intakeTimeFrame = 'Midnight to Midnight'
				me.numLoginsAllowed = 'Multiple logins'
				me.timeToComplete = 'By midnight'
				break;
			case 'SRS':
				me.studyTool = ''
				me.studyType = '';
				me.numConsecutiveDays = '';
				me.numRecords = '';
				me.studyTool = 'RECALL STUDY'
				me.studyType = 'SCHEDULED'
				me.totalRecallsRespondent = '3'
				me.intakeTimeFrame = 'Midnight to Midnight'
				me.numLoginsAllowed = 'Multiple logins'
				me.timeToComplete = 'By midnight'
				break;
			case '3dCDRS':
				me.studyTool = ''
				me.studyType = '';
				me.totalRecallsRespondent = '';
				me.intakeTimeFrame = '';
				me.numLoginsAllowed = '';
				me.timeToComplete = '';
				me.studyTool = 'RECORD STUDY'
				me.studyType = 'CONSECUTIVE_DAY'
				me.numConsecutiveDays = '3'
				me.numRecords = '1'
				break;
			case 'SDRS':
				me.studyTool = ''
				me.studyType = '';
				me.totalRecallsRespondent = '';
				me.intakeTimeFrame = '';
				me.numLoginsAllowed = '';
				me.timeToComplete = '';
				me.studyTool = 'RECORD STUDY'
				me.studyType = 'SINGLE_DAY'
				me.numRecords = '1'
				break;
			default:
    // code block
			}
		},
		isModuleAllowed: function (moduleName) {
			const checkedModuleNames = ['Respondent Nutrition Report', 'Sleep', 'Supplements'];
			const moduleRnr = moduleName === checkedModuleNames[0] && moduleService.isModuleRNRAllowed(this.version, this.studyType).isModuleAllowed;
			const moduleSleep = moduleName === checkedModuleNames[1] && moduleService.isModuleSleepAllowed(this.version);
			const moduleSupplements = moduleName === checkedModuleNames[2] && moduleService.isModuleSupplementsAllowed(this.version);
			const moduleAnythingElse = !checkedModuleNames.includes(moduleName);

			return moduleRnr || moduleSleep || moduleSupplements || moduleAnythingElse;
		},
		focusToTop () {
			var myHeader = document.getElementById('skipToMain')
			myHeader.focus()
		},
		isLetter (e) {
			const char = String.fromCharCode(e.keyCode); // Get the character
			if (/^[A-Za-z]+$/.test(char)) return true; // Match with regex
			else e.preventDefault(); // If not match, don't add to input text
		}
	},
	computed: {
		filteredTableRowList: function () {
			var temp = [];
			for (var i = 0; i < this.tableRowList.length; i++) {
				if (this.tableRowList[i].displayCondition === false || (this.tableRowList[i].displayCondition === true && (this[this.tableRowList[i].inputVarName].length !== 0))) {
					temp.push(this.tableRowList[i]);
					if (this.tableRowList[i].name === 'Study type') {
						if (this.studyTool === this.$createStudyLists.studyTools[0].name) {
							temp[temp.length - 1].icon = 'warning';
							temp[temp.length - 1].iconColor = '#f6800a'
						} else {
							temp[temp.length - 1].icon = 'lock';
							temp[temp.length - 1].iconColor = '#FB5051'
						}
					}
				} else if (this.tableRowList[i].displayCondition === true) {
					// Fields can be saved without input and can have an error, if there is an error it should show in the summary page.
					for (var j = 0; j < this.errorListSummary.length; j++) {
						if (this.errorListSummary[j].fieldId.includes(this.tableRowList[i].fieldId)) {
							temp.push(this.tableRowList[i]);
						}
					}
				}
			}

			for (let i = 0; i < temp.length; i++) {
				switch (temp[i].icon) {
				case 'lock_open':
					temp[i].iconLabel = 'Can be changed later';
					temp[i].iconColor = '#1c7f20';
					break;
				case 'warning':
					temp[i].iconLabel = 'Can be changed until respondent accounts are created';
					temp[i].iconColor = '#be4800';
					break;
				case 'lock':
					temp[i].iconLabel = 'Cannot be changed after study is created';
					temp[i].iconColor = '#d32829';
					break;
				default:
					temp[i].iconLabel = '';
				}
			}

			return temp;
		},
		optionsRNR: function () {
			return this.$createStudyLists.optionsRNR;
		},
		newStudy: function () {
			console.log('new study')
			const unixStartDate = new Date(this.startDate).getTime();
			const unixEndDate = new Date(this.endDate).getTime();
			const fundingObject = {};
			fundingObject.listOfFunds = this.fundingSourceToSave
			fundingObject.selection = this.fundsReceived
			fundingObject.otherText = this.fundsReceivedOther
			let suplementBoolean = this.optionalStudyModules.includes('Supplements')
			if (this.version >= 23) {
				suplementBoolean = true
			}

			// Handle recipeModule. This is not exposed as an option. It is turned on/off at the study version level.
			let recipeModule = false;
			if (this.version) {
				recipeModule = this.$store.getters.getStudyVersionRecipeModule(this.version);
			}

			// Handle default settings due to Record Study Tool selection
			if (this.studyTool === this.$createStudyLists.studyTools[1].name) {
				// Record Study only allows midnight to midnight intake
				this.intakeTimeFrame = this.$createStudyLists.INTAKE_MIDNIGHT_TO_MIDNIGHT.key;
				// Record Study only allow multiple logins
				this.numLoginsAllowed = this.$createStudyLists.loginsAllowedList[1];
			}

			var study = {
				numRecordsPerParticipant: (this.numRecords ? parseInt(this.numRecords) : 0),
				numParticipants: (this.respondentNum ? parseInt(this.respondentNum) : 0),
				description: this.studyDescription,
				studyName: this.studyName,
				version: this.version,
				studyUuid: this.studyUuid,
				studyId: this.studyAbbreviation,
				tvModule: this.optionalStudyModules.includes('TV/Computer Use'),
				midnightTimeFrame: this.intakeTimeFrame === this.$createStudyLists.INTAKE_MIDNIGHT_TO_MIDNIGHT.key ? this.$createStudyLists.INTAKE_MIDNIGHT_TO_MIDNIGHT.value : this.$createStudyLists.INTAKE_24_HOURS.value,
				shortName: null, // not set during creation
				sourceModule: this.optionalStudyModules.includes('Source'),
				recipeModule: recipeModule,
				recordStudyType: (this.studyTool === this.$createStudyLists.studyTools[1].name ? this.studyType : null),
				currentStudyStatus: '', // set by the method that is using this object
				// supplementModule: false, // not set during creation
				supplementModule: suplementBoolean,
				numConsecutiveRecordDays: (this.numConsecutiveDays ? parseInt(this.numConsecutiveDays) : 0),
				primaryEmail: this.$store.getters.getUserInfo.userName,
				locationModule: this.optionalStudyModules.includes('Location'),
				numberHoursToComplete: (this.timeToComplete !== '' ? (this.timeToComplete === this.$createStudyLists.timeToCompleteList[0] ? 24 : 32) : 0),
				validateRecallDates: false, // not set during creation
				isRemote: false, // not set during creation
				nutritionProfileModule: this.optionalStudyModules.includes('Respondent Nutrition Report'),
				nutritionProfileModuleShowReport: this.convertShowRNR(this.showRNR),
				dateEnd: (this.endDate === '' ? 0 : unixEndDate),
				secret: null, // not set during creation
				dateStart: (this.startDate === '' ? 0 : unixStartDate),
				numRecallsPerParticipant: (this.totalRecallsRespondent ? parseInt(this.totalRecallsRespondent) : 0),
				eatWithModule: this.optionalStudyModules.includes('Ate with others'),
				multipleSessions: (this.numLoginsAllowed === this.$createStudyLists.loginsAllowedList[1]), // if RECORD STUDY, then true; else if numLoginsAllowed is 'Multiple logins', then true; else false
				recallType: (this.studyTool === this.$createStudyLists.studyTools[0].name ? this.studyType : ''),
				sourceList: JSON.stringify(this.fundingSourceToSave), // nothing changed, want to confirm confirmed right set up
				// sourceList: '', //  keeping here while confirmed right set up
				purposeType: JSON.stringify(this.studyPurposeToSave),
				funding: JSON.stringify(fundingObject), /// object with fields selection and listOfFunds
				researchType: JSON.stringify(this.researchTypeToSave),
				organizationType: JSON.stringify(this.researcherAffiliationToSave),
				studyCharacteristics: JSON.stringify(this.studyCharacteristics),
				studyTool: (this.studyTool === this.$createStudyLists.studyTools[1].name ? 'RECORD' : 'RECALL'),
				grantContractNumber: this.contractNum,
				sleepModule: this.optionalStudyModules.includes('Sleep')
			}
			return study;
		},
		isErrorListEmpty: function () {
			return this.errorListSummary.length === 0;
		},
		studyPurposeToSave: function () {
			// If 'other' is selected the saved value should be the user input
			if (this.studyPurposeOther === '' || this.studyPurpose !== this.$createStudyLists.studyPurposes[4]) {
				return { selection: this.studyPurpose, value: this.studyPurpose };
			} else {
				return { selection: this.studyPurpose, value: this.studyPurposeOther };
			}
		},
		researchTypeToSave: function () {
			var temp = [];
			for (var i = 0; i < this.researchType.length; i++) {
				if (this.researchType[i] !== this.$createStudyLists.researchTypes[5]) {
					temp.push({ selection: this.researchType[i], value: this.researchType[i] })
				} else {
					temp.push({ selection: this.researchType[i], value: this.researchTypeOther })
				}
			}
			return temp;
		},
		fundingSourceToSave: function () {
			var temp = [];
			for (var i = 0; i < this.fundingSource.length; i++) {
				if (this.fundingSource[i] === this.$createStudyLists.fundingSources[2].name) {
					temp.push({ selection: this.fundingSource[i], value: this.fundingSourceOther })
				} else if (this.fundingSource[i] === this.$createStudyLists.fundingSources[0].subCategories[5].alias) {
					temp.push({ selection: this.fundingSource[i], value: this.fundingSourceNIHOther })
				} else if (this.fundingSource[i] === this.$createStudyLists.fundingSources[1].subCategories[4].alias) {
					temp.push({ selection: this.fundingSource[i], value: this.fundingSourceAgencyOther })
				} else {
					temp.push({ selection: this.fundingSource[i], value: this.fundingSource[i] })
				}
			}

			return temp;
		},
		researcherAffiliationToSave: function () {
			var temp = [];
			for (var i = 0; i < this.researcherAffiliation.length; i++) {
				if (this.researcherAffiliation[i] === this.$createStudyLists.researcherAffiliations[1]) {
					temp.push({ selection: this.researcherAffiliation[i], value: this.researcherAffiliationAgency })
				} else if (this.researcherAffiliation[i] === this.$createStudyLists.researcherAffiliations[4]) {
					temp.push({ selection: this.researcherAffiliation[i], value: this.researcherAffiliationOrganization })
				} else if (this.researcherAffiliation[i] === this.$createStudyLists.researcherAffiliations[5]) {
					temp.push({ selection: this.researcherAffiliation[i], value: this.researcherAffiliationClient })
				} else if (this.researcherAffiliation[i] === this.$createStudyLists.researcherAffiliations[6]) {
					temp.push({ selection: this.researcherAffiliation[i], value: this.researcherAffiliationOther })
				} else {
					temp.push({ selection: this.researcherAffiliation[i], value: this.researcherAffiliation[i] })
				}
			}

			return temp;
		},
		getActiveStudyVersions: function () {
			return this.$store.getters.getActiveStudyVersions;
		}
	}
}
</script>

<style>

@media only screen and (max-width: 1000px)
    {
        .v-stepper__label {
            display: flex !important;
        }
    }

@media only screen and (max-width: 470px)
    {
        .v-stepper__label {
					display: flex !important;
          font-size: 10px;
        }
    }

</style>
